@import '../../../sass/bootstrap/pre-default';
@import '../../../sass/colors';
@import '../../../sass/spacers';
@import '../../../sass/bootstrap-ext/variables';
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.site-search-desktop-wrapper {
  background-color: $vt-white;

  @include media-breakpoint-down(lg) {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
